import { isPlatformServer } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { ConfigService } from '@core/frontend-shared';
import * as i0 from "@angular/core";
import * as i1 from "@core/frontend-shared";
export let MembershipRegistrationCartService = /*#__PURE__*/(() => {
  class MembershipRegistrationCartService {
    constructor(ngPlatformId, config) {
      this.config = config;
      this.cart = [];
      this.isSSR = isPlatformServer(ngPlatformId);
      // this.setupCheckout();
    }
    reset() {
      this.cart = [];
    }
    addCartItem(item) {
      this.cart.push({
        item,
        value: this.calculateCartItemValue(item)
      });
    }
    // async setupCheckout() {
    // 	const plugin = await firstValueFrom(this.activePlugin$);
    // 	const cart = plugin.getCart();
    // 	cart.forEach(item=>this.paypal.addCartItem(item));
    // }
    calculateCartItemValue(item) {
      const quantity = item.quantity || 1;
      const taxMultiplier = item.tax || 0.19;
      const netValue = item.value;
      const taxValue = netValue * taxMultiplier;
      const grossValue = netValue + taxValue;
      return {
        quantity,
        taxMultiplier,
        netValue,
        taxValue,
        grossValue
      };
    }
    getItemsAndValue() {
      return [...this.cart];
    }
    getCartTotals() {
      return this.cart.reduce((totals, item) => {
        return {
          netValue: totals.netValue + item.value.netValue * item.value.quantity,
          taxValue: totals.netValue + item.value.taxValue * item.value.quantity,
          grossValue: totals.netValue + item.value.grossValue * item.value.quantity
        };
      }, {
        netValue: 0,
        taxValue: 0,
        grossValue: 0
      });
    }
    static {
      this.ɵfac = function MembershipRegistrationCartService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MembershipRegistrationCartService)(i0.ɵɵinject(PLATFORM_ID), i0.ɵɵinject(i1.ConfigService));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: MembershipRegistrationCartService,
        factory: MembershipRegistrationCartService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return MembershipRegistrationCartService;
})();